import React from 'react';

export default function Privacy() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Privacy Policy</h1>
      <p>
        This website respects user privacy and does not collect, store, or share any personal information. We do not require
        user registration, and no identifiable data is retained on our servers.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        Our service may utilize third-party APIs to fetch media content. We do not control or store any of the media retrieved
        through these services. Users are responsible for complying with the terms of service of third-party providers.
      </p>
      <h2>No Media Hosting</h2>
      <p>
        We do not host any videos, music, or other media files on our servers. This website only facilitates the retrieval of
        publicly available media content through valid URLs provided by users.
      </p>
    </div>
  );
}
